import {availableLocales} from "./locales";
import Vue from 'vue';
import VueI18n from 'vue-i18n';
import {messages} from './translations';

export const defaultLocale = availableLocales.DE;
Vue.use(VueI18n);

const i18n = new VueI18n({
  locale: defaultLocale,
  messages
});

export default i18n;